export function formatNumber(number, opt) {
    var _a = (opt || {}).splited, splited = _a === void 0 ? false : _a;
    if (typeof +number !== 'number') {
        return '-';
    }
    var strArr = [number + '', ''];
    [{
            number: 100000000,
            text: '亿'
        }, {
            number: 10000,
            text: '万'
        }].some(function (v) {
        if (number >= v.number) {
            var str = (number / v.number).toFixed(1) + '';
            if (str[str.length - 1] === '0') {
                str = str.slice(0, str.length - 2);
            }
            strArr = [str, v.text];
            return true;
        }
    });
    return splited ? strArr : strArr.join('');
}
export default {
    formatNumber: formatNumber,
};
//# sourceMappingURL=number.js.map